import { Caption, HelpIcon } from 'canoe';
import React from 'react';

import { isTooltipNode } from 'craft/constants';
import { useResolver } from 'craft/hooks';

export const BlockedDisplayWarning = ({ type }: { type?: string }) => {
  const resolver = useResolver(type);

  let text = `Other layout controls are unavailable for this component type.`;
  if (resolver?.craft?.isCanvas) {
    text = `Other layout controls are not available for ${type}. Place a Layout or another Component inside to arrange content.`;
  }
  if (type === 'CheckListGroup') {
    text = 'Other layout controls are available within each Checklist Item.';
  }

  if (isTooltipNode(type)) {
    // special case where hotspots are not the root but are the content document when selected
    return null;
  }

  return (
    <div css={{ display: 'flex' }}>
      <HelpIcon color="OnyxGrayL30" size="s" />
      <Caption color="OnyxGrayL30" css={{ paddingLeft: '8px' }} mb="none">
        {text}
      </Caption>
    </div>
  );
};
